<template>
    <div class="module">
        <header class="module__header">
            <router-link
                tag="a"
                class="back-btn"
                :to="{ name: 'super-roles' }"
            >
                <span class="icon-chevron-left"></span>
            </router-link>
            <h1 class="has-back-btn">Create Role</h1>
        </header>

        <section class="module__body">
            <form
                class="full-width"
                @submit.prevent="createRole"
            >
                <div class="form-group">
                    <label for="name">Name</label>
                    <input
                        id="name"
                        v-model="name"
                        type="text"
                        required
                        maxlength="20"
                    />
                </div>

                <div class="form-group multi-select">
                    <multi-select-field
                        :allItems="allPermissions"
                        label="Permissions"
                        testId="permissions-select"
                        :selectedValues="selectedPermissionIdsArray"
                        @items-selected="handlePermissionsSelected"
                        @items-unselected="handlePermissionsUnselected"
                    ></multi-select-field>
                </div>

                <form-errors :response="errorResponse"></form-errors>

                <div class="form-group">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        :class="{ active: submitted }"
                    >
                        <div>Create</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'
import MultiSelectField from '@/components/MultiSelectField.vue'

export default {
    components: {
        FormErrors,
        MultiSelectField,
    },

    mixins: [canToast],

    data() {
        return {
            name: null,
            allPermissions: [],
            selectedPermissionIds: new Set(),
            errorResponse: null,
            submitted: false,
        }
    },

    computed: {
        selectedPermissionIdsArray() {
            return Array.from(this.selectedPermissionIds)
        },
    },

    mounted() {
        this.$http.get('/permissions/all').then(({ data }) => {
            this.allPermissions = data.map(({ id, name }) => ({
                id,
                name,
            }))
        })
    },

    methods: {
        createRole() {
            this.submitted = true

            this.$http
                .post('roles', {
                    name: this.name,
                    permissions: this.selectedPermissionIdsArray,
                })
                .then(() => {
                    this.toast('Role successfully added!')
                    this.$router.push('/roles')
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },

        handlePermissionsSelected(ids) {
            ids.forEach((id) => {
                this.selectedPermissionIds.add(id)
            })
        },
        handlePermissionsUnselected(ids) {
            ids.forEach((id) => {
                this.selectedPermissionIds.delete(id)
            })
        },
    },
}
</script>
